import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class HostListenerService {
	private scrollSubject = new Subject<Event>();
	public scrollListener = this.scrollSubject.asObservable();

	scrollEmitter(event: Event) {
		this.scrollSubject.next(event);
	}
}
